import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44f6dd84"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-wrap col-12 align-items-center\" data-v-44f6dd84><div class=\"line-title\" data-v-44f6dd84> Welcome  <div style=\"white-space:nowrap;\" class=\"d-flex align-items-center col\" data-v-44f6dd84> back <div class=\"line-visual\" data-v-44f6dd84></div></div></div></div><h1 class=\"mb-0 mt-2 h2\" data-v-44f6dd84>Log in to your account</h1>", 2)
const _hoisted_3 = { class: "col-12 login-form py-3 py-lg-5" }
const _hoisted_4 = { class: "d-flex flex-column flex-wrap" }
const _hoisted_5 = { class: "mb-3 row flex-wrap gy-2" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "col-auto" }

import { ElMessage } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import { onBeforeMount, reactive, ref, Ref } from "vue";
import { ValidateFieldsError } from "async-validator";
import { useAuthStore } from "@/stores/auth";
import { ApiAccountLoginPostRequest } from "@/api-client";
import { useRoute, useRouter } from "vue-router";
import { handleInvalidForm } from "@/utilities/api";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props) {

const authStore = useAuthStore();
const loginFormRef = ref<FormInstance>();
let formData = reactive<ApiAccountLoginPostRequest>({
  email: "",
  password: "",
});
let returnUrl: Ref<string | null> = ref(null);
const route = useRoute();
const router = useRouter();
// let rememberMe: Ref<boolean> = ref(false);

const rules = reactive<FormRules<ApiAccountLoginPostRequest>>({
  email: [{ required: true, type: "email", message: "Please enter a valid email address", trigger: "change" }],
  password: [{ required: true, message: "Please enter a password", trigger: "change" }],
});

onBeforeMount(() => {
  if (route.query.returnUrl) {
    returnUrl.value = route.query.returnUrl as string;
  }
});

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      await authStore.login(formData).then(() => {
        if (returnUrl.value) {
          router.push({ path: `${returnUrl.value}` });
        // } else if (route.fullPath.includes("admin")) {
        //   router.push({ name: "AdminDashboard" });
        } else {
          router.push({ name: "Dashboard" });
        }
      });
      console.log("valid");
      // handle valid
    } else {
      handleInvalidForm(fields as ValidateFieldsError);
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_form, {
        ref_key: "loginFormRef",
        ref: loginFormRef,
        model: _unref(formData),
        rules: rules,
        size: "large",
        "label-position": "top",
        "require-asterisk-position": "right"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_form_item, {
              class: "col-12 pb-2 mb-3 mb-md-4",
              label: "Email",
              prop: "email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  name: "email",
                  type: "email",
                  modelValue: _unref(formData).email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).email) = $event)),
                  placeholder: "Enter your email (*)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 pb-2 mb-3 mb-md-4",
              label: "Password",
              prop: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formData).password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).password) = $event)),
                  name: "password",
                  type: "password",
                  placeholder: "Enter your password (*)",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (submitForm(loginFormRef.value)))
              }, "Login")
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: { name: 'Register' },
                class: "btn btn-outline-primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Register a new account")
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_router_link, {
            class: "small",
            to: { name: 'ForgotPassword' }
          }, {
            default: _withCtx(() => [
              _createTextVNode("Forgot password?")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ], 64))
}
}

})